import { createContext, useContext, useState, type ReactNode } from 'react';

/** Global search query shared between the Topbar input and the active route. */
const SearchCtx = createContext<{ query: string; setQuery: (q: string) => void }>({
  query: '',
  setQuery: () => {},
});

export function SearchProvider({ children }: { children: ReactNode }) {
  const [query, setQuery] = useState('');
  return <SearchCtx.Provider value={{ query, setQuery }}>{children}</SearchCtx.Provider>;
}

export function useSearch() {
  return useContext(SearchCtx);
}
